import { render, staticRenderFns } from "./CollectionEditView.vue?vue&type=template&id=b06c041e"
import script from "./CollectionEditView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionEditView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports